import React from 'react';

export interface IconTwitterProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconTwitter: React.FC<IconTwitterProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M4.0485 20.25L10.121 13.3388L10.5278 12.8758L10.1525 12.387L3.52137 3.75H7.95552L12.0981 9.20412L12.653 9.93471L13.2587 9.24562L18.089 3.75H19.1601L13.5532 10.1289L13.1483 10.5895L13.5193 11.0778L20.4882 20.25H16.1982L11.5863 14.2515L11.0304 13.5284L10.4283 14.2136L5.12432 20.25H4.0485Z" fill={fill || "#020617"}  stroke={stroke || "#020617"}  strokeWidth="1.5" />  
    </svg>
  );
};

export default IconTwitter;
